import { useCallback } from 'react';
import { NFTI } from '@tacans/shared-marketplace-layer';

import { selectNftSales, getNftSalesThunk } from 'src/features/common/collectible/ducks/nft-sales';
import { actions } from 'src/features/common/collectible/ducks/nft-sales/nft-sales.slice';
import { useAppDispatch, useAppSelector } from 'src/hooks/app';

export function useGetNftSales() {
    const dispatch = useAppDispatch();
    const nftSales = useNftSales();

    return useCallback(
        async (nftIds: NFTI['id'][]) => {
            const filtered = nftIds.filter(nftId => !nftSales[nftId]);

            if (filtered.length) {
                clearTimeout(useGetNftSales.fetchSalesRef);
                useGetNftSales.fetchSalesList = [...new Set([
                    ...useGetNftSales.fetchSalesList,
                    ...filtered
                ])];
                useGetNftSales.fetchSalesRef = setTimeout(() => {
                    actions.startFetching(useGetNftSales.fetchSalesList);
                    dispatch(getNftSalesThunk(useGetNftSales.fetchSalesList));
                    useGetNftSales.fetchSalesList = [];
                }, 100);
            }
        },
        [nftSales, dispatch],
    );
}

useGetNftSales.fetchSalesList = [] as string[];
useGetNftSales.fetchSalesRef = null as any;

export const useNftSales = () => useAppSelector(selectNftSales);
